import TrackerContainer from './TrackerContainer';
export const getTracker = () => {
  return TrackerContainer;
};